import { LeadsSearchQuery } from '@mm/state/interfaces/leads';
import { Slider } from 'antd';
import { isEqual } from 'lodash';
import React, { useEffect, useState } from 'react';
import { parseAge } from '../helpers';
import styles from './AgeSlider.module.css';

export const AGE_KEY = 'AGE';

export const AgeSlider = ({
  disabled,
  filterParams,
  setFilterParams,
}: {
  disabled: boolean;
  filterParams: LeadsSearchQuery;
  setFilterParams: (params: LeadsSearchQuery) => void;
}) => {
  const minAge = 18;
  const maxAge = 100;
  const baseAge: [number, number] = [minAge, maxAge];
  const defaultValue = parseAge(filterParams.query, AGE_KEY) || baseAge;
  const [age, setAge] = useState<[number, number]>(defaultValue);

  const onAfterChange = (ageRange: [number, number]) => {
    const ageStr = ageRange.join('-');

    const paramsExcludingAge = filterParams.query.filter(
      arr => !arr.some(i => i === AGE_KEY),
    );

    const queryWithReset = isEqual(baseAge, ageRange)
      ? paramsExcludingAge
      : [...paramsExcludingAge, [AGE_KEY, ageStr]];

    const updatedQuery = {
      query: queryWithReset,
      exclude: filterParams.exclude,
      offset: 0,
    } as LeadsSearchQuery;

    setFilterParams(updatedQuery);
  };

  useEffect(() => {
    if (!filterParams.query?.filter(item => item.includes(AGE_KEY)).length) {
      setAge(baseAge);
    }
  }, [filterParams.query]);

  return (
    <div className={styles.container}>
      <Slider
        rootClassName={styles.slider}
        min={minAge}
        max={maxAge}
        step={1}
        range={{ draggableTrack: true }}
        tooltip={{
          placement: 'bottom',
          open: true,
          getPopupContainer: element =>
            element.parentElement ? element.parentElement : document.body,
        }}
        trackStyle={[{ backgroundColor: 'var(--color-geekblue-6' }]}
        railStyle={{ backgroundColor: '#CDDEF7' }}
        onChange={ageRange => setAge(ageRange)}
        disabled={disabled}
        value={age}
        onAfterChange={ageRange => onAfterChange(ageRange)}
      />
    </div>
  );
};
